{
  "savedViews.browse.cappedCount": "İlk {{count}} sonuç tutuldu",
  "savedViews.browse.default": "Varsayılan görünüm",
  "savedViews.browse.definitionSummary": "{{filters}} filtre · {{columns}} sütun",
  "savedViews.browse.emptyDescription": "Burada çalıştırmak için Görevler, Projeler, Yaşam, Notlar, Bilgiler, Dönemler veya Günlük'ten bir filtre kaydedin.",
  "savedViews.browse.emptyTitle": "Henüz kayıtlı görünüm yok",
  "savedViews.browse.fields.display_label": "Etiket",
  "savedViews.browse.fields.entry_kind": "Tür",
  "savedViews.browse.fields.item_type": "Tür",
  "savedViews.browse.fields.occurred_at": "Gerçekleşme",
  "savedViews.browse.fields.start_date": "Başlangıç",
  "savedViews.browse.fields.end_date": "Bitiş",
  "savedViews.browse.fields.updated": "Güncelleme",
  "savedViews.browse.legacyDefinition": "Taşıma gerekli",
  "savedViews.browse.lede": "Kaydettiğiniz filtreleri, sahip oldukları koleksiyonlarda tek bir yerden çalıştırın.",
  "savedViews.browse.listTitle": "Görünümler",
  "savedViews.browse.loadError": "Kayıtlı görünümler yüklenemedi",
  "savedViews.browse.loadMore": "Daha fazla sonuç yükle",
  "savedViews.browse.matchCount": "{{count}} eşleşme",
  "savedViews.browse.no": "Hayır",
  "savedViews.browse.noResults": "Eşleşen kayıt yok",
  "savedViews.browse.noResultsDescription": "Görünüm başarıyla çalıştı ancak filtreleriyle eşleşen etkin kayıt yok.",
  "savedViews.browse.noSelection": "Bir kayıtlı görünüm seçin",
  "savedViews.browse.openRecord": "Kaydı aç",
  "savedViews.browse.pinned": "Sabitlenmiş görünüm",
  "savedViews.browse.resultsDescription": "{{surface}} koleksiyonundan canlı sonuçlar",
  "savedViews.browse.resultsError": "Bu kayıtlı görünüm çalıştırılamadı",
  "savedViews.browse.resultsTitle": "Sonuçlar",
  "savedViews.browse.selectDescription": "Doğrulanmış filtrelerini çalıştırmak için bir görünüm seçin.",
  "savedViews.browse.title": "Kayıtlı görünümler",
  "savedViews.browse.unknownSurface": "Koleksiyon",
  "savedViews.browse.viewCount": "{{count}} görünüm",
  "savedViews.browse.yes": "Evet",
  "savedViews.publicLinks.actionErrorDescription": "Herkese açık bağlantı işlemi tamamlanamadı.",
  "savedViews.publicLinks.active": "Etkin",
  "savedViews.publicLinks.activeCount": "Etkin bağlantı: {{count}}",
  "savedViews.publicLinks.cancel": "Vazgeç",
  "savedViews.publicLinks.confirmRevoke": "Bağlantıyı iptal et",
  "savedViews.publicLinks.copied": "Herkese açık bağlantı kopyalandı.",
  "savedViews.publicLinks.copy": "Bağlantıyı kopyala",
  "savedViews.publicLinks.copyError": "Herkese açık bağlantı kopyalanamadı.",
  "savedViews.publicLinks.copyLabel": "{{date}} tarihinde sona eren {{kind}} bağlantısını kopyala",
  "savedViews.publicLinks.create": "Bağlantı oluştur",
  "savedViews.publicLinks.createForm": "Herkese açık bağlantı oluştur",
  "savedViews.publicLinks.created": "Yeni bir herkese açık bağlantı oluşturuldu.",
  "savedViews.publicLinks.credentialWarning": "Bu bağlantıya sahip olan herkes, süresi dolana veya siz iptal edene kadar sınırlandırılmış sonucu okuyabilir.",
  "savedViews.publicLinks.description": "Seçili görünüm için anonim ve salt okunur bağlantılar oluşturun, inceleyin ve iptal edin.",
  "savedViews.publicLinks.emptyDescription": "Bir geçerlilik süresi seçip ilk anonim salt okunur bağlantıyı oluşturun.",
  "savedViews.publicLinks.emptyTitle": "Bu görünüm için herkese açık bağlantı yok",
  "savedViews.publicLinks.enable": "Herkese açık bağlantılara izin ver",
  "savedViews.publicLinks.enableDescription": "Bu işlem yalnızca açıkça oluşturulan süreli bağlantılara izin verir; görünümü tek başına yayımlamaz.",
  "savedViews.publicLinks.enableTitle": "Önce bu görünümü paylaşılabilir yapın",
  "savedViews.publicLinks.expired": "Etkin değil · süresi doldu",
  "savedViews.publicLinks.expiresAt": "Bitiş: {{date}}",
  "savedViews.publicLinks.expiry": "Geçerlilik süresi",
  "savedViews.publicLinks.expiry.1": "1 saat",
  "savedViews.publicLinks.expiry.24": "24 saat",
  "savedViews.publicLinks.expiry.168": "7 gün",
  "savedViews.publicLinks.expiry.720": "30 gün",
  "savedViews.publicLinks.kind": "Herkese açık biçim",
  "savedViews.publicLinks.kindReport": "Rapor",
  "savedViews.publicLinks.kindView": "Kayıtlı görünüm",
  "savedViews.publicLinks.listLabel": "Seçili görünümün herkese açık bağlantıları",
  "savedViews.publicLinks.loadError": "Herkese açık bağlantılar yüklenemedi",
  "savedViews.publicLinks.open": "Aç",
  "savedViews.publicLinks.openLabel": "{{date}} tarihinde sona eren {{kind}} bağlantısını aç",
  "savedViews.publicLinks.pdf": "PDF",
  "savedViews.publicLinks.pdfLabel": "{{date}} tarihinde sona eren {{kind}} bağlantısının PDF'sini aç",
  "savedViews.publicLinks.print": "Yazdırma görünümü",
  "savedViews.publicLinks.printLabel": "{{date}} tarihinde sona eren {{kind}} bağlantısının yazdırma görünümünü aç",
  "savedViews.publicLinks.private": "Özel",
  "savedViews.publicLinks.privateInactive": "Etkin değil · görünüm özel",
  "savedViews.publicLinks.revoke": "İptal et",
  "savedViews.publicLinks.revokeConflict": "Bu bağlantı başka bir yerde değişti. Güncel durum yüklendi; yeniden denemeden önce inceleyin.",
  "savedViews.publicLinks.revokeLabel": "{{date}} tarihinde sona eren {{kind}} bağlantısını iptal et",
  "savedViews.publicLinks.revokePrompt": "Bu URL hemen çalışmayı durduracak. İptal edilsin mi?",
  "savedViews.publicLinks.revoked": "Etkin değil · iptal edildi",
  "savedViews.publicLinks.revokedSuccess": "Herkese açık bağlantı iptal edildi.",
  "savedViews.publicLinks.shareableEnabled": "Bu görünüm için artık herkese açık bağlantılara izin veriliyor.",
  "savedViews.publicLinks.title": "Herkese açık bağlantılar",
  "savedViews.publicLinks.visibilityConflict": "Görünüm başka bir yerde değişti. Güncel durumu yükleniyor; herkese açık bağlantıları etkinleştirmeden önce inceleyin.",
  "savedViews.surfaces.journal": "Günlük",
  "savedViews.surfaces.knowledge": "Bilgiler",
  "savedViews.surfaces.lifeRecords": "Yaşam kayıtları",
  "savedViews.surfaces.notes": "Notlar",
  "savedViews.surfaces.periods": "Dönemler"
}
